// extracted by mini-css-extract-plugin
export default {"backModal":"Modal_backModal__i0ueo","modal":"Modal_modal__yEgVW","cont":"Modal_cont__f3sNV","title":"Modal_title__KuCmT","closeBtn":"Modal_closeBtn__-YU4n"};